<template>
    <div>
        <menu-button @click="print" label="Print" :icon-class="'app-icon-printer'"></menu-button>
        <menu-dialog
            :is-open="isOpen"
            title="Select View to Print"
            :show-close-button="true"
            @close="isOpen = false"
            width="300px">
            <div class="app-print-dialog-buttons">
                <menu-button class="app-print-button" @click="printWeek" label="Week" :is-primary="true" />
                <menu-button class="app-print-button" @click="printMonth" label="Month" :is-primary="true" />
            </div>
        </menu-dialog>
    </div>
</template>
<script>
    import dmUtils from '../../../../dmFramework/dmJS/dmUtils';
import adaMixin from '../../../js/mixins/adaMixin';

    export default {
        name: 'print-button',
        components: {
            'menu-button': () => import('../../../components/menuButton.vue'),
            'menu-dialog': () => import('../../../components/menuDialog.vue')
        },
        mixins: [adaMixin],
        props: {
            siteID: Number,
            mealTimeId: Number,
            startDate: String
        },
        data() {
            return {
                isOpen: false
            };
        },
        methods: {
            print() {
                this.isOpen = true;
            },
            printWeek() {
                this.isOpen = false;

                setTimeout(() => {
                    window.print();
                })
            },
            printMonth() {
                this.isOpen = false;
                setTimeout(() => {
                    var startDate = moment(dmUtils.parseDateInput(this.startDate)).set("date", 1).format("MM/DD/YYYY");
                    const url = window.apiRoot + "/PDF/print?subSiteID=" + this.siteID + "&mealTimeId=" + this.mealTimeId + "&startDateTime=" + startDate;
                    console.log("Opening URL for print month:", url);
                    window.open(url, '_blank');
                })
            }
        }
    };
</script>
<style scoped>
    .app-print-dialog-buttons {
        display: flex;
        flex-direction: row;
        gap: 8px;
        justify-content: space-around;
    }
</style>